import { Box, Typography } from "@mui/material";
import { memo } from "react";
import vegIcon from "../../../Assets/Veg_symbol.svg.png";
import nonVegIcon from "../../../Assets/Non_veg_symbol.svg.png";
import eggIcon from "../../../Assets/Egg.svg";

type ProductSummaryProps = {
  item: any;
  key: number;
}

const ProductSummary = ({ item, key }: ProductSummaryProps) => {
  return (
    <>
      <Box key={key}>
        <Box
          key={key}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={0.5}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <img
              src={
                (item.product_type ?? "").toLowerCase() === "veg"
                  ? vegIcon
                  : (item.product_type ?? "").toLowerCase() === "non-veg"
                  ? nonVegIcon
                  : (item.product_type ?? "").toLowerCase() === "egg"
                  ? eggIcon
                  : ""
              }
              alt={item.product_type}
              style={{ width: 14, height: 14 }}
            />
            <Typography fontSize={12}>
              {item.product_name} x {item.quantity}
            </Typography>
          </Box>
          <Typography fontSize={12} fontWeight={500}>
            ₹{item.price?.toFixed(2) * item.quantity}
          </Typography>
        </Box>
        {item.addons && item.addons.length > 0 && (
          <Box sx={{ width: "100%", mb: 1 }}>
            {item.addons.map((addon, j) => (
              <Box
                key={addon.id || j}
                display="flex"
                justifyContent="space-between"
                width="100%"
                sx={{ pl: 2.5 }}
              >
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ display: "block", pr: 1 }}
                >
                  • {addon.product_name} x {addon.quantity}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ display: "block" }}
                >
                  ₹{addon.price?.toFixed(2)}
                </Typography>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </>
  );
};

const ProductDetails = () => {
  return (
    <>
      
    </>
  );
};

export const Product = {
  Summary: memo(ProductSummary),
  Details: memo(ProductDetails),
};
